import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { logoColor } from '../../ui/media';
import { useForgotPassword } from '../../../hooks/useAuth';
import { themeStore } from '../../../stores/theme';
import { useStore } from '@tanstack/react-store';
import toast from 'react-hot-toast';

const ForgotPassword = () => {
  const { isDarkMode } = useStore(themeStore)
  const navigate = useNavigate()
  const ForgotMutation = useForgotPassword()
  const [email, setEmail] = useState('');

  const handleForgot = () => {
    if(email == ""){
      toast.error("Email is not allowed to empty")
      return
    }
    ForgotMutation.mutate({ email}, {
      onSuccess: () => {
        navigate(`/otp-verification/${encodeURIComponent(email)}`)    
      },
      onError: (error) => {
        const message = error.response?.data?.message || "Server Error"
        toast.error(message)
      }
    })
  };

  const Logo = () => {
    return (
      <div className="flex flex-col items-center">
        <img src={logoColor} className='h-[70px]' />
      </div>
    );
  };

  return (
    <div className={`min-h-screen flex items-center justify-center p-4`}>
      <div className={`w-full max-w-md rounded-lg shadow-lg mt-[70px] overflow-hidden ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
        {/* Logo Header */}
        <div className="bg-blue-100 w-[95%] mx-auto my-3 rounded-lg p-6 flex justify-center">
          <div className="flex flex-col items-center">
            <Logo />
          </div>
        </div>
        <h1 className={`text-2xl poppins-regular font-bold mt-4 text-center ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>Forgot Password</h1>
        <p className={`text-sm mt-2 text-center ${isDarkMode ? 'text-white' : 'text-gray-600'}`}>
          Please enter your registered email address<br />to reset your account password.
        </p>
        {/* Forgot Form */}
        <div className="p-6">
          <div className="mb-4">
            <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-white' : 'text-gray-600'} `}>Email</label>
            <div className="relative">
              <input
                placeholder='Enter email address'
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={`w-full p-3 rounded border ${isDarkMode
                    ? 'bg-gray-700 border-gray-600 text-white'
                    : 'bg-white border-gray-300'
                  }`}
              />
              <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                <Mail size={18} className="text-blue-600" />
              </div>
            </div>
          </div>
          <div className='text-center'>
            <button
              onClick={handleForgot}
              disabled={ForgotMutation.isLoading?true:false}
              className="w-[200px] poppins-regular bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-full text-center">
                {ForgotMutation.isLoading? "Please wait...": "Send Reset Email" }
            </button>
          </div>
        </div>
        {/* Footer Link */}
        <div className={`p-4 text-center ${isDarkMode ? 'bg-gray-700' : 'bg-blue-100'}`}>
          <p className={`${isDarkMode ? 'text-white' : 'text-gray-600'}`}>
            Back to Login Page ?
            <button
              onClick={() => navigate("/login")}
              className="ml-1 poppins-regular font-bold text-blue-600 hover:underline">
              Click Here
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};
export default ForgotPassword